<template>  
  <!-- <el-dialog
      v-if="editDialogVisible"
      :title="$t('login.login')"
      :lock-scroll="true"
      :show-close="true"
      :visible.sync="editDialogVisible"
      width="90%"
      :modal="true"
    >
      <add-edit-com :isLoginDialog="true"/>
    </el-dialog> -->
    <add-edit-com :isLoginDialog="true"/>
</template>

<script>
import addEditCom from '@/views/login/index.vue'

export default {
  name: 'loginDialogForm',
  components: { addEditCom },
  data() {
    return {
      // editDialogVisible: false
    }
  },
  methods: { 
    // openDialog(){
    //   this.editDialogVisible = true
    // },
    // closeDialog(){
    //   this.editDialogVisible = false
    // }
  }
}
</script>
